//import Link from "next/link";
import { Carousel } from "react-bootstrap";

const About = () => {
    return (
        <center>
            <div id="about" className="py-10 mt-16 mb-60 ">
                <div className="container relative max-w-6xl py-3 pt-16 mx-auto mt-18 sm:max-w-xl sm:mx-auto">
                    <div className="absolute inset-0 transform shadow-lg gradient-background -skew-y-6sm:skew-y-0 sm:-rotate-6 sm:rounded-3xl"></div>
                    <div className="relative px-4 py-10 bg-white shadow-lg sm:rounded-3xl sm:p-20">
                        <div className="max-w-md mx-auto">
                            <div>
                                <h1 className="text-3xl font-bold text-gray-900">
                                    THE METAMALL STORES
                                </h1>
                            </div>
                            <div class="row">
                                <div id="sample" class="col-sm">

                                    <Carousel className="m-5">
                                        <Carousel.Item interval={2000}>
                                            <img
                                                className="d-block w-300"
                                                src="metamall.gif"
                                                alt="Resim One"
                                            />
                                            <Carousel.Caption>
                                                <h3>Metamall NFT Samples</h3>
                                                <p>Sample 1</p>
                                            </Carousel.Caption>
                                        </Carousel.Item>
                                        <Carousel.Item interval={500}>
                                            <img
                                                className="d-block w-500"
                                                src="metamall.gif"
                                                alt="Resim Two"
                                            />
                                            <Carousel.Caption>
                                                <h3>Metamall NFT Samples</h3>
                                                <p>Sample 2</p>
                                            </Carousel.Caption>
                                        </Carousel.Item>
                                    </Carousel>

                                </div>
                                <div class="col-sm">
                                    <div className="divide-y divide-gray-100">
                                        <div className="py-8 space-y-8 text-base leading-6 text-gray-700 sm:text-lg sm:leading-7">
                                            <br />
                                            <br />
                                            <br />
                                            <ul className="space-y-2 list-disc listem">
                                                <li className="flex items-start">
                                                    <p className="ml-5">
                                                        <code className="font-semibold text-gray-900">{" "} Only 2,500</code>{" "}
                                                        ERC-721 NFTs.
                                                    </p>
                                                </li>

                                                <li className="flex items-start">
                                                    <p className="ml-2">
                                                        Bridge between Metamall stores and real world stores.
                                                    </p>
                                                </li>
                                                <li className="flex items-start">
                                                    <p className="ml-2">
                                                        Investors who own Metaverse Mall NFTs can add their real commercial site addresses as a feature..
                                                    </p>
                                                </li>
                                                <li className="flex items-start">
                                                    <p className="ml-2">Begin 0.006 ETH per Stores.</p>
                                                </li>
                                            </ul>
                                        </div>
                                        <br />
                                        <br />
                                        <div className="pt-6 text-base leading-6 font-extralight sm:text-lg sm:leading-7">
                                            <p>
                                                {`With Metaverse you are faced with a hybrid application of real world data..`}
                                            </p>
                                        </div>
                                    </div>
                                </div>
                            </div>


                        </div>
                    </div>
                </div>
            </div >
        </center>
    );
};

export default About;
